/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { ProductConstants } from '../actions/actionType';

export function wishList(state = {}, action) {
    switch (action.type) {
    case ProductConstants.GET_WISHLIST_LIST_SUCCESS:
        return {
            type: ProductConstants.GET_WISHLIST_LIST_SUCCESS,
            list: action.user.data.data,
        };
    case ProductConstants.GET_WISHLIST_LIST_FAILURE:
        return {
            type: ProductConstants.GET_DISTRIBUTORS_SUCCESS,
            message: action.message,
        };
    case ProductConstants.GET_WISHLIST_SELECTED_ITEM:
        return {...state,
            selected:action.user.data
                
        };
        
    default:
        return state;
    }
}
